export const CHANGE_JOB_TITLE = 'api-gateway/v1.0/profile/job-title'
export const CHANGE_PHONE_NUMBER = 'api-gateway/v1.0/profile/change-phone'
export const ATTACHED_RESUME_VALIDATE = 'attached-resumes-validation/v1/validate-resume'
export const UPDATE_RESUME_FILE = 'api-gateway/v2.0/profile/update-resume-file'
export const ENDPOINT_UPDATE_RESUME_FILE = 'profile/update-resume-file'
export const PROFILE_LEVEL = 'api-gateway/v1.0/profile/level'
export const RESUME_SETTING_INFO = 'api-gateway/v2.0/profile/resume-setting-info'
export const UPDATE_RESUME_SETTING_INFO = 'api-gateway/v1.0/profile/cookie'
export const JOBLEVEL = 'meta/v1.0/job-levels'
export const BASIC_INFO = 'api-gateway/v1.0/profile/basic-info'
export const SEARCHABLE = 'api-gateway/v1.0/profile/resume-change-searchable'
export const PROFILE_COOKIE = 'api-gateway/v1.0/profile/cookie'
export const SKILL_TAGS = 'skill-tags/api/v1/skills/suggestion'
export const REFRESH_PROFILE = 'api-gateway/v1.0/profile/refresh-profile'
export const USER_SKILL = 'api-gateway/v1.0/profile/skill'
export const BASIC_INFO_V2 = 'api-gateway/v2.0/profile/info'

export const DEFAULT_ALLOW_FILES_EXT = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
]
export const DEFAULT_ALLOW_IMAGE_MINETYPE_EXT = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif']
export const DEFAULT_ALLOW_EXT =
    '.doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf'
export const DEFAULT_AVATAR_ALLOW_EXT = '.jpg,.png,.jpeg,.gif'
export const DEFAULT_1MB_SIZE = 1000000
export const DEFAULT_1KB_SIZE = 1000
export const DEFAULT_LIMIT_FILE_SIZE = 5120000 // 5MB
export const DEFAULT_SUCCESS_CODE = 200
export const DEFAULT_MAX_LENGTH_JOB_TITLE = 80
export const DEFAULT_LIMIT_AVATAR_SIZE = DEFAULT_1MB_SIZE * 10 // 10MB
